import { ContactQuestion } from "./contact-question";
import type { QuestionTypeRendererProps } from "./shared";

type EmailQuestionProps = QuestionTypeRendererProps<"email">;

export default function EmailQuestionType(props: EmailQuestionProps) {
  return <ContactQuestion {...props} kind="email" />;
}
